import { render, staticRenderFns } from "./createNxThOrder.vue?vue&type=template&id=a64e0c6a&scoped=true"
import script from "./createNxThOrder.vue?vue&type=script&lang=js"
export * from "./createNxThOrder.vue?vue&type=script&lang=js"
import style0 from "./createNxThOrder.vue?vue&type=style&index=0&id=a64e0c6a&prod&scoped=true&lang=css"
import style1 from "./createNxThOrder.vue?vue&type=style&index=1&id=a64e0c6a&prod&lang=css"
import style2 from "./createNxThOrder.vue?vue&type=style&index=2&id=a64e0c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64e0c6a",
  null
  
)

export default component.exports